var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"exportbtn",staticClass:"btn",class:{
    'btn-success': _vm.success,
    'btn-outline-primary': !_vm.success,
  },attrs:{"disabled":_vm.loading,"data-bs-toggle":"tooltip","data-bs-placement":"top","title":_vm.$t('Export with enabled filters')},on:{"click":_vm.handleExportCSV}},[(_vm.success)?_c('span',[_vm._v(_vm._s(_vm._f("translate")('Download CSV')))]):(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_c('span',[_vm._v(_vm._s(_vm._f("translate")('Export CSV')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }